import db from '../../js/db'
import * as types from '../mutations-types'
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import { firestoreAction, vuexfireMutations } from 'vuexfire'

const state = {
  my: {},
}

// getters
const getters = {
  // `myPlan` includes generated empty slots, so it cannot tell whether the
  // user has ever saved a plan. This is used to distinguish first setup from
  // an explicit choice to leave every optional slot without a budget.
  hasPlanSalvato: state => Object.keys(state.my || {}).some(
    ruolo => Object.keys(state.my[ruolo] || {}).length > 0
  ),
  myPlanCompleto: (state, getters, rootState, rootGetters) => getMyPlan(state, getters, rootState, rootGetters),
  myPlan: (state, getters) => filterPlan(getters.myPlanCompleto, false),
  myPlanFuoriLimite: (state, getters) => filterPlan(getters.myPlanCompleto, true),
  planDefault: (state, getters, rootState, rootGetters) => getPlanDefault(state, getters, rootState, rootGetters),
  svincolatiPerAutocomplete: (state, getters, rootState, rootGetters) => getSvincolatiPerAutocomplete(state, getters, rootState, rootGetters),
  associati: (state, getters, rootState, rootGetters) => getAssociati(state, getters, rootState, rootGetters),
  acquistiSenzaSlotPerRuolo: (state, getters, rootState, rootGetters) => {
    const output = {};
    const associati = new Set(getters.associati.map(String));
    const rosa = (rootGetters.my_squadra || {}).calciatori || {};
    const catalogo = rootGetters.calciatori || {};
    for (const ruolo in Constants.RUOLO) {
      output[ruolo] = Object.keys(rosa).filter(id =>
        !associati.has(String(id)) && catalogo[id] &&
        Number(catalogo[id].ID_Ruolo) === Number(Constants.RUOLO[ruolo])
      );
    }
    return output;
  },
}

function getAssociati(state, getters, rootState, rootGetters) {
  let output = [];
  const myPlan = getters.myPlanCompleto
  for (const ruolo_abc in myPlan) {
    for (const i in myPlan[ruolo_abc]) {
      const associato = myPlan[ruolo_abc][i]["associato"];
      if (associato != "") {
        output.push(associato);
      }
    }
  }
  return output;
}

// The saved plan stays untouched: changing the rules only changes which slots
// are available. Slots with data can therefore be restored when limits rise.
function filterPlan(plan, fuoriLimite) {
  const output = {};
  for (const ruolo in plan) {
    output[ruolo] = {};
    for (const slot in plan[ruolo]) {
      if (!!plan[ruolo][slot].fuoriLimite === fuoriLimite) {
        output[ruolo][slot] = plan[ruolo][slot];
      }
    }
  }
  return output;
}

function getMyPlan(state, getters, rootState, rootGetters) {
  const squadra = rootGetters.my_squadra;
  if (!squadra) return {};

  const output = _.cloneDeep(getters.planDefault);
  const op = rootGetters.asta_info.lega.nRuoli.op;
  const hasMaximum = op === "=" || op === "<=";
  for (const ruolo in output) {
    const capacity = Object.keys(output[ruolo]).length;
    const savedSlots = (state.my || {})[ruolo] || {};
    const orderedKeys = Object.keys(savedSlots).sort(
      (a, b) => Number(a.slice(1)) - Number(b.slice(1))
    );
    for (const slot of orderedKeys) {
      if (!/^_[1-9]\d*$/.test(slot)) continue;
      const available = !!output[ruolo][slot];
      const saved = _.cloneDeep(savedSlots[slot]);
      const data = { calciatori: [], crediti: 0, associato: "", ...saved };
      if (data.associato && !(squadra.calciatori || {})[data.associato]) {
        data.associato = "";
      }
      const hasData = data.associato || Number(data.crediti) ||
        Object.values(data.calciatori || []).some(id => id != null && id !== "");
      if (available || hasData) {
        output[ruolo][slot] = {
          ...data,
          fuoriLimite: !available && hasMaximum,
        };
      }
    }
    if (op === "illimitati") {
      // Keep the user's occupied positions; only empty slots are retired.
      const slots = Object.keys(output[ruolo]).sort(
        (a, b) => Number(a.slice(1)) - Number(b.slice(1))
      );
      const occupied = slots.filter(slot => output[ruolo][slot].associato);
      const active = new Set(occupied);
      for (const slot of slots) {
        if (active.size >= capacity) break;
        if (Number(slot.slice(1)) <= capacity) active.add(slot);
      }
      for (const slot of slots) {
        output[ruolo][slot].fuoriLimite = !active.has(slot);
      }
    }
  }
  return output;
}

function getPlanDefault(state, getters, rootState, rootGetters) {
  const my_squadra = rootGetters.my_squadra;
  const asta_info = rootGetters.asta_info;
  if (!my_squadra) return {};
  let output = {};
  for (const ruolo_abc in Constants.RUOLO) {
    const ruolo_id = Constants.RUOLO[ruolo_abc];
    let nRuolo = 0;
    if (asta_info.lega.nRuoli.op == "illimitati") {
      nRuolo =
        my_squadra.settings.plan.nRuoli[Helpers.ruoloLega(ruolo_id)];
      const acquisti = Object.keys(my_squadra.calciatori || {}).filter(id =>
        rootGetters.calciatori && rootGetters.calciatori[id] &&
        Number(rootGetters.calciatori[id].ID_Ruolo) === Number(ruolo_id)
      ).length;
      nRuolo = Math.max(Number(nRuolo) || 0, acquisti);
    } else {
      nRuolo = asta_info.lega.nRuoli[Helpers.ruoloLega(ruolo_id)];
    }
    output[ruolo_abc] = planRuoloDefault(nRuolo);
  }
  return output;
}

function getSvincolatiPerAutocomplete(state, getters, rootState, rootGetters) {
  let output = {};
  const nameFilter = "";
  const maxQuotazione = 0;
  const includiScartati = false;
  for (const ruolo_abc in Constants.RUOLO) {
    const ruolo_id = Constants.RUOLO[ruolo_abc];
    let ids = rootGetters.svincolati(
      ruolo_id,
      nameFilter,
      maxQuotazione,
      includiScartati
    );
    let objects = _.orderBy(_.map(ids, (id) => {
      return {
        text: rootGetters.calciatori[id].calciatore,
        value: id,
      };
    }), ["text"], ["asc"]);
    output[ruolo_abc] = objects;
  }
  return output;
}

function planRuoloDefault(nRuolo) {
  let output = {};
  for (let i = 1; i <= nRuolo; i++) {
    output["_" + i] = {
      calciatori: [],
      crediti: 0,
      associato: "",
    };
  }
  return output;
}

// actions
const actions = {
  associaAcquistoIllimitato({ getters, rootGetters }, acquisto) {
    const squadra = rootGetters.my_squadra;
    if (!squadra || String(squadra.id) !== String(acquisto.squadra_id) ||
        rootGetters.asta_info.lega.nRuoli.op !== "illimitati") return;
    const id = String(acquisto.calciatore_id);
    if (getters.associati.map(String).includes(id)) return;
    const calciatore = (rootGetters.calciatori || {})[id];
    if (!calciatore) return;
    const ruolo = Object.keys(Constants.RUOLO).find(
      key => Number(Constants.RUOLO[key]) === Number(calciatore.ID_Ruolo)
    );
    if (!ruolo) return;
    const slots = getters.myPlan[ruolo] || {};
    const free = Object.keys(slots).filter(slot => !slots[slot].associato);
    let target = free.find(slot =>
      Object.values(slots[slot].calciatori || []).map(String).includes(id)
    );
    if (!target) {
      const budgeted = free.filter(slot => Number(slots[slot].crediti) > 0);
      budgeted.sort((a, b) =>
        Math.abs(Number(slots[a].crediti) - Number(acquisto.prezzo || 0)) -
        Math.abs(Number(slots[b].crediti) - Number(acquisto.prezzo || 0))
      );
      target = budgeted[0] || free[0];
    }
    if (!target) {
      // The assignment log can arrive before the updated roster. Reserve a new
      // key without overwriting any saved (possibly retired) slot.
      const keys = Object.keys(getters.myPlanCompleto[ruolo] || {});
      target = "_" + (Math.max(0, ...keys.map(key => Number(key.slice(1)) || 0)) + 1);
    }
    return db.setPlanAssociato(ruolo, target, id);
  },
  fetchMyPlan() {
    db.fetchMyPlan()
  },
  // not used
  updateMyPlan({
    commit,
    state
  }, value) {
    commit(types.PLAN_UPD, value)
  }
}

// mutations
const mutations = {
  [types.PLAN_SET](state, plan) {
    state.my = plan;
  },
  [types.PLAN_UPD](state, values) {
    state.my = _.merge(state.my, values)
  },
  [types.PLAN_CLR](state) {
    state.my = {};
  },
  ...vuexfireMutations
}

export default {
  state,
  getters,
  actions,
  mutations
}
